import {
  useDisclosure,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Modal,
  Button,
  Text,
  VStack,
  HStack,
  Avatar,
  Flex,
  Divider,
} from "@chakra-ui/react";
import React, { Dispatch, SetStateAction, useState } from "react";
import { format } from "date-fns";
import { OriginalSizePhoto } from "../OriginalSizePhoto";

import { BiImage } from "react-icons/bi";

import { UserProps } from "../../pages/Users";

interface Request {
  user: UserProps;
  setUser: Dispatch<SetStateAction<UserProps>>;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
  openModal: boolean;
}

export function UserModal({ user, setUser, openModal, setOpenModal }: Request) {
  console.log(user);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [scrollBehavior, setScrollBehavior] = React.useState("inside");

  const [url, setUrl] = useState("");
  const closeModal = () => {
    setOpenModal(false);
  };

  const btnRef = React.useRef(null);

  const handleOpenImage = (imageKey: string) => {
    setUrl(`https://qth-files.s3.sa-east-1.amazonaws.com/${imageKey}`);
  };
  return (
    <>
      <Modal onClose={closeModal} isOpen={openModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Dados do Motorista</ModalHeader>
          <ModalCloseButton onClick={closeModal} />
          <ModalBody>
            <HStack w="100%" justifyContent="space-between">
              <Flex flex="1">
                <Avatar
                  size="2xl"
                  name={user.name}
                  onClick={() => handleOpenImage(user.documentImage)}
                  src={`https://qth-files.s3.sa-east-1.amazonaws.com/${user.documentImage}`}
                />
              </Flex>
              <Flex
                flexDirection="column"
                justifyContent="space-around"
                flex="1"
                h="100px"
              >
                <Text>
                  Nome: <strong>{user.name}</strong>{" "}
                </Text>

                <Text>
                  CPF: <strong>{user.cpfCnpj}</strong>{" "}
                </Text>

                <Text>
                  Registrou-se em:{" "}
                  <strong>
                    {format(new Date(user.createdAt), "dd/MM/yyyy")}
                  </strong>{" "}
                </Text>

                <Text>
                  Telefone: <strong>{user.mobile}</strong>{" "}
                </Text>

                <Button
                  mt={2}
                  textDecoration="underline"
                  leftIcon={<BiImage />}
                  onClick={() => handleOpenImage(user.document)}
                >
                  Ver CNH
                </Button>
              </Flex>
            </HStack>

            <Divider mt={25} />

            <Text fontWeight="bold" mb={5}>
              Histórico de Pagamentos
            </Text>

            {user.payments.map((i) => (
              <HStack key={i._id} w="100%" justifyContent="space-between">
                <Text>{i.plan?.description}</Text>
                <Text>
                  Expira em:{" "}
                  {i.expiresIn
                    ? format(new Date(i.expiresIn), "dd/MM/yyyy")
                    : ""}
                </Text>
              </HStack>
            ))}
          </ModalBody>
          <ModalFooter>
            <Button onClick={closeModal}>Fechar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {url && <OriginalSizePhoto setUrl={setUrl} url={url} />}
    </>
  );
}
